import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostData,
  type CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostError,
  type CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostResponse,
  createIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPost,
} from '../../generated';

export type CreateIdeaMutationVariables = CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostData['path'];

export type CreateIdeaMutation = CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostResponse;

export const useCreateIdeaMutation = <
  TError = CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<CreateIdeaMutation, TError, CreateIdeaMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<CreateIdeaMutation, TError, CreateIdeaMutationVariables, TContext>({
    mutationKey: ['CreateIdea'],
    mutationFn: async ({ portfolio_id, image_id }: CreateIdeaMutationVariables) => {
      const { data } = await createIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPost({
        path: { portfolio_id, image_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useCreateIdeaMutation.fetcher = (
  { portfolio_id, image_id }: CreateIdeaMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await createIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPost({
      path: { portfolio_id, image_id },
      throwOnError: true,
    });
    return data;
  };
};
